
import img0 from './Images/Account_Registration.png';
  
const content = `# OnData Account Registration
  
To use the OnData Platform, the first thing is to register for an organization account at the OnData Portal. Only one administrative user needs to sign up for 
an organization account at the OnData Portal. By default, the administrative user signing up for the OnData organization account has the "System Administrator" 
role to the OnData Platform. Once an organization account is registered and approved, the System Administrator can invite other users to join, or configure 
Single Sign-On (SSO) integration with the organization's existing Identity and Access Management (IAM) system so that other users can access the OnData services 
using their existing credentials. Below are the details on how to create an organization account.  

## Registration Steps
  
a. An administrative user can visit the OnData Portal at https://us.ondatahub.com/register  
b. Enter \`First Name\`, \`Last Name\`, and \`Work Email Address\`, and click on the \`Register\` button to initiate the registration process. Please note that the typical 
personal email domains such as \`yahoo.com\`, \`gmail.com\`, or \`hotmail.com\` cannot be used to sign up for an organization account. Please use your work email 
address instead  
  
![Account Registration](${ img0 })
  
c. OnData will review your registration request and may reach out to you for a brief meeting to learn your data security needs. If the OnData solution is a good 
fit for your needs, OnData will approve your registration request, and you will receive an email from OnData regarding the next steps. Please click on the 
\`Verify Email\` button to verify your email and complete all necessary data fields on the page to complete the registration process  
d. Once the account registration process is completed, OnData will assign your organization account all OnData products that your organization has subscribed to. 
The complete list of OnData products includes:  
* SecureDB - A OnData product for discovering, managing, and protecting structured data in databases and semi-structured data files  
* SecureFile - A OnData product for discovering, managing, and protecting unstructured data in documents and files  
* SecureAI - A OnData product for discovering and protecting sensitive data when such data is used with GenAI  
  
e. The user who signed up for a OnData organization account has the "System Administrator" role to the OnData Platform. The System Administrator user can login 
to the OnData Portal at https://us.ondatahub.com/login and further configure the organization account  
  
`
  
export default content;
